var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 4.66667C1.33333 3.78261 1.68452 2.93477 2.30964 2.30964C2.93476 1.68452 3.7826 1.33333 4.66666 1.33333C5.55071 1.33333 6.39856 1.68452 7.02368 2.30964C7.6488 2.93477 7.99999 3.78261 7.99999 4.66667C7.99999 5.55072 7.6488 6.39857 7.02368 7.02369C6.39856 7.64881 5.55071 8 4.66666 8C3.7826 8 2.93476 7.64881 2.30964 7.02369C1.68452 6.39857 1.33333 5.55072 1.33333 4.66667ZM4.66666 1.47055e-07C3.9275 1.40653e-06 3.19891 0.175584 2.54089 0.512288C1.88288 0.848992 1.31425 1.33719 0.881843 1.93667C0.449435 2.53615 0.165613 3.22978 0.0537507 3.96042C-0.058112 4.69107 0.0051838 5.43784 0.238426 6.13923C0.471668 6.84063 0.868184 7.47659 1.39532 7.99474C1.92246 8.51289 2.56514 8.89842 3.27044 9.11957C3.97575 9.34072 4.72349 9.39117 5.45211 9.26676C6.18072 9.14235 6.86936 8.84665 7.46133 8.404L10.8613 11.8047C10.9863 11.9298 11.1559 12.0001 11.3328 12.0001C11.5096 12.0002 11.6792 11.93 11.8043 11.805C11.9294 11.68 11.9997 11.5104 11.9998 11.3336C11.9999 11.1567 11.9297 10.9871 11.8047 10.862L8.40466 7.462C8.92355 6.76834 9.23912 5.94395 9.31606 5.08111C9.39299 4.21828 9.22824 3.35105 8.84026 2.57654C8.45227 1.80202 7.85637 1.15079 7.11925 0.695735C6.38214 0.240684 5.53292 -0.000217283 4.66666 1.47055e-07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.61ae0b566ff746b13fa5664347736b65.svg";
export { ForwardRef as ReactComponent };